import { useState } from 'react'
import { Input } from 'sfy-react'
import styles from './ChatMessage.module.scss'
import { ReactComponent as Send } from '../../../assets/images/send.svg'
import { ReactComponent as Mic } from '../../../assets/images/mic.svg'

const ChatMessage = ({ callExternalHandler }) => {
  const [text, setText] = useState('')
  const [isTalking, setIsTalking] = useState(false)

  const handleOnChange = (e) => {
    setText(e.target.value)
  }

  const handleOnMicClick = async () => {
    try {
      let recognization = new window.webkitSpeechRecognition()
      recognization.onstart = () => {
        setIsTalking(true)
      }
      recognization.onresult = async (e) => {
        const transcript = e.results[0][0].transcript
        setIsTalking(false)
        setText('')
        await callExternalHandler({ message: transcript })
      }
      recognization.onend = (e) => {
        setIsTalking(false)
      }
      recognization.onerror = (e) => {
        console.log(e)
        setIsTalking(false)
      }
      recognization.start()
    } catch (e) {
      console.log(e)
    }
  }

  const handleOnSubmit = async (message) => {
    setText('')
    await callExternalHandler({ message })
  }

  return (
    <Input
      id='message'
      name='message'
      value={text || ''}
      className={{
        formControl: `${styles['message-form-control']}`,
        inputContainer: `${styles['message-input-container']}`,
        input: `${styles['message-input']}`,
      }}
      placeholder={'Ask Noah'}
      handleOnChange={handleOnChange}
      otherProps={{
        autoComplete: 'off',
        onKeyDown: (e) => {
          if (e.key === 'Enter') {
            handleOnSubmit(e.target.value)
          }
        },
      }}
    >
      {text && (
        <Send
          onClick={() => {
            handleOnSubmit(text)
          }}
          tabIndex={0}
          className={styles['send-image']}
        />
      )}
      {isTalking ? (
        <img className={styles['audio-image']} src={`${window.appName}/images/sound.gif`} alt='sound' />
      ) : (
        <Mic onClick={handleOnMicClick} className='mr12' tabIndex={0} />
      )}
    </Input>
  )
}

export default ChatMessage
